import { Descriptions } from 'app/modules/ui';
import React from 'react';
import {
  DESCRIPTION_ACTUAL_PRODUCT_INFO,
  DESCRIPTION_ADDITIONAL_INFO,
  DESCRIPTION_PRODUCT_PREFERENCE,
  LABEL_WIDTH
} from './config';
import { ShippingInformation } from 'app/definitions/interfaces/Product';
import { Divider } from 'antd';
import classes from './ShippingInformationItem.module.scss';

type BaseRecord = {
  [key: string]: string;
};

type ShippingInformationDetailProps = {
  value: BaseRecord;
  shippingInformation: ShippingInformation;
};

export const ShippingInformationDetail = (
  props: ShippingInformationDetailProps
) => {
  const { value, shippingInformation } = props;

  return (
    <div className={classes.detail}>
      <Descriptions
        className={classes['detail__product-preference']}
        column={1}
        colon={false}
        title="Product Info Reference"
        items={
          DESCRIPTION_PRODUCT_PREFERENCE.map((item) => ({
            ...item,
            labelStyle: { width: LABEL_WIDTH }
          })) as any
        }
        value={{
          ...value
        }}
        meta={{
          shippingInformation
        }}
      />
      <Divider />
      <Descriptions
        className={classes['detail__actual-info']}
        colon={false}
        column={1}
        title="Actual Product Info"
        items={
          DESCRIPTION_ACTUAL_PRODUCT_INFO.map((item) => ({
            ...item,
            labelStyle: { width: LABEL_WIDTH }
          })) as any
        }
        value={{
          ...value
        }}
        meta={{
          shippingInformation
        }}
      />
      <Divider />
      <Descriptions
        className={classes['detail__additional-info']}
        column={1}
        colon={false}
        items={
          DESCRIPTION_ADDITIONAL_INFO.map((item) => ({
            ...item,
            labelStyle: { width: LABEL_WIDTH }
          })) as any
        }
        value={{
          ...value
        }}
        meta={{
          shippingInformation
        }}
      />
    </div>
  );
};
